import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-project-infoclass',
  templateUrl: './edit-project-infoclass.component.html',
  styleUrls: ['./edit-project-infoclass.component.scss']
})
export class EditProjectInfoclassComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
